import Button from "@mui/material/Button";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";

/**
 * Google's own branding for a sign-in button (owner 2026-10-25, "google
 * button like Cashfree"): white, the four-colour G, "Sign in with Google",
 * Roboto 500 14px, #747775 border, 4px corners. It starts OUR intent, as
 * before; it is not Google's personalised (GIS) button.
 */
export function GoogleSignInButton({ disabled, onClick, testId }: { disabled?: boolean; onClick: () => void; testId?: string }) {
  return (
    <Button
      variant="outlined"
      disabled={disabled}
      onClick={onClick}
      data-testid={testId}
      startIcon={<GoogleG />}
      sx={{
        bgcolor: "#FFFFFF",
        color: "#1F1F1F",
        borderColor: "#747775",
        borderRadius: "4px",
        height: 40,
        textTransform: "none",
        fontFamily: "Roboto, Arial, sans-serif",
        fontWeight: 500,
        fontSize: 14,
        "&:hover": { bgcolor: "#F8F9FA", borderColor: "#747775" },
      }}
    >
      Sign in with Google
    </Button>
  );
}

function GoogleG() {
  return (
    <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
      <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
      <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
      <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
      <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
    </svg>
  );
}

/** Owner 2026-10-25: the Terms and Privacy line under the sign-in buttons. Opens in a new tab so the sign-in is not lost. */
export function LegalConsentLine() {
  return (
    <Typography variant="caption" color="text.secondary" align="center" data-testid="legal-consent">
      By continuing you agree to our{" "}
      <Link href="/legal/terms" target="_blank" rel="noopener">
        Terms of Service
      </Link>{" "}
      and{" "}
      <Link href="/legal/privacy" target="_blank" rel="noopener">
        Privacy Policy
      </Link>
      .
    </Typography>
  );
}

